import { useEffect } from "react";
import { Link } from "react-router-dom";
import useScrollAnimation from "../../hooks/useScrollAnimation";
import Navbar from "../home/components/Navbar";
import Footer from "../home/components/Footer";

const BRANDS = [
  { name: "ADN Kuruyemiş", img: "/images/ADN-KURUYEMIS-OSMANIYE-1-76031067.png" },
  { name: "Akdeniz Kebap", img: "/images/akdeniz-kebap-logo-c107eef4.png" },
  { name: "Akdeniz Reform", img: "/images/akdeniz-reform-insaat-logo-978daa49.png" },
  { name: "Altınordu Spor", img: "/images/altonordu-spor-logo-7a07bc4c.png" },
  { name: "Arifzade", img: "/images/ARIFZADE-CIGKOFTE-VE-MEZE-f2b06430.png" },
  { name: "CarnevalKids", img: "/images/carnavalkids-logo-5c8bb033.png" },
  { name: "Cızzgara", img: "/images/CIZZGARA-LOGO-3fbd4bd6.png" },
  { name: "Corner Cafe", img: "/images/CORNER-LOUNGUE-CAFE-LOGO-9d1a1328.png" },
  { name: "Emsav Emniyet", img: "/images/emsav-emniyet-logo-86de7dac.png" },
  { name: "Emsav", img: "/images/emsav-logo-1-84e012ea.png" },
  { name: "Ergün Oto", img: "/images/ERGUN-OTO-LOGO-d4f1f619.png" },
  { name: "Essel Kağıt", img: "/images/essel-kagit-logo-scaled-e6a4cfdb.png" },
  { name: "Hadise", img: "/images/hadise-logo-63b8eba3.png" },
  { name: "Kemal Pastanesi", img: "/images/kemal-pastanesi-efe479ea.png" },
  { name: "Kepirler Künefe", img: "/images/kepirler-kunefe-logo-857d44ad.png" },
  { name: "Lavas Center", img: "/images/lavas-canter-logo-cd9ca80b.png" },
  { name: "MG Dino Döner", img: "/images/mg-dino-doner-logo-c62baec7.png" },
  { name: "Bakraç Cafe", img: "/images/osmaniye-bakrach-cafe-logo-63209019.png" },
  { name: "Büyük Otel", img: "/images/osmaniye-buyuk-oteli-logo-2-61883df7.png" },
  { name: "Osmaniyespor", img: "/images/osmaniye-spor-logo-d60e0788.png" },
  { name: "OSB", img: "/images/osmaniye-osb-logo-44adce8b.webp" },
  { name: "Uğrak", img: "/images/UGRAK-LOGO-0d96e870.png" },
  { name: "Yöresel Reyon", img: "/images/yoresel-reyon-gurme-logo-f1bdeac7.png" },
  { name: "Arifzade Çiğköfte ve Meze", img: "/images/referans/AR%C4%B0FZADE%20%C3%87%C4%B0%C4%9EK%C3%96FTE%20VE%20MEZE.png" },
  { name: "Baylaz Group", img: "/images/referans/BAYLAZ%20GROUP.jpg" },
  { name: "Karaca Home", img: "/images/referans/Karaca-Home-New-2022-Logo-Vector.svg-.png" },
  { name: "Mono Çelik Kapı", img: "/images/referans/mono%20%C3%A7elik%20kap%C4%B1.jpg" },
  { name: "Sevgi Hastahanesi", img: "/images/referans/SEVG%C4%B0%20HASTAHANES%C4%B0.png" },
  { name: "Öncü", img: "/images/referans/%C3%B6nc%C3%BC%20png.png" },
];

const ReferanslarPage = () => {
  useScrollAnimation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <section className="relative pt-32 pb-20 bg-[#0D0D0D] overflow-hidden">
        <div className="absolute inset-0 opacity-15">
          <img
            src="/images/neden-vip-reklam-806d6601.jpg"
            alt="Referanslar"
            className="w-full h-full object-cover object-center"
          />
        </div>
        <div className="absolute top-0 left-0 w-1.5 h-full bg-[#E6A800]" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">
          <div className="flex items-center gap-2 mb-6 anim-down d0">
            <Link to="/" className="text-white/40 text-xs font-head hover:text-[#E6A800] tr uppercase tracking-wider">
              Ana Sayfa
            </Link>
            <i className="ri-arrow-right-s-line text-white/30 text-xs" />
            <span className="text-[#E6A800] text-xs font-head uppercase tracking-wider">Referanslar</span>
          </div>
          <div className="flex items-center gap-3 mb-5 anim-left d1">
            <div className="w-8 h-[2px] bg-[#E6A800]" />
            <span className="font-head text-[#E6A800] text-xs font-700 uppercase tracking-[0.2em]">Güven & Başarı</span>
          </div>
          <h1 className="font-head font-black uppercase text-white text-[clamp(48px,8vw,100px)] leading-[0.88] anim-up d2">
            Birlikte Çalıştığımız
            <br />
            <span className="text-[#E6A800]">Markalar</span>
          </h1>
          <p className="text-white/50 text-sm leading-relaxed max-w-xl mt-6 anim-up d3">
            Osmaniye ve çevresinde farklı sektörlerden yüzlerce işletmeyle
            uzun soluklu iş birlikleri kurduk. Referanslarımız, proje kalitemizin
            ve teslim disiplinimizin en güçlü göstergesidir.
          </p>
        </div>
      </section>

      <section className="py-20 bg-[#F7F7F7] border-y border-[#ECECEC]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
            {BRANDS.map((brand, i) => (
              <div
                key={brand.name}
                className="bg-white border border-[#E9E9E9] hover:border-[#E6A800] tr p-5 h-[110px] flex items-center justify-center anim-up"
                style={{ transitionDelay: `${i * 35}ms` }}
                title={brand.name}
              >
                <img
                  src={brand.img}
                  alt={brand.name}
                  className="max-h-[58px] max-w-[150px] object-contain filter grayscale hover:grayscale-0 tr"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#181614]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 text-center anim-scale">
          <div className="w-10 h-[3px] bg-[#E6A800] mx-auto mb-5" />
          <h2 className="font-head font-black uppercase text-white text-4xl md:text-5xl leading-[0.9] mb-5">
            Markanız İçin
            <br />
            <span className="text-[#E6A800]">Bir Sonraki Başarı Hikayesi</span>
          </h2>
          <p className="text-white/60 text-sm leading-relaxed max-w-2xl mx-auto mb-8">
            Referanslarımız arasına katılmak için ücretsiz keşif ve proje planlaması
            desteği alın.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link
              to="/hizmetler"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#E6A800] text-white hover:bg-[#C99500] tr font-head font-700 uppercase text-xs tracking-wider"
            >
              Hizmetleri İncele
              <i className="ri-arrow-right-line" />
            </Link>
            <a
              href="tel:+905511830918"
              className="inline-flex items-center gap-2 px-6 py-3 border border-white/25 text-white hover:bg-white/10 tr font-head font-700 uppercase text-xs tracking-wider"
            >
              <i className="ri-phone-line" />
              +90 551 183 09 18
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ReferanslarPage;
